import React, { useEffect, useState } from 'react';
import EditsRenderData from './EditsRenderData';
import { TabViewContainer } from '../../../commonComponents/TabViewContainer';
import { Spinner } from '../../../commonComponents/Spinner';
import { Colors } from '../../../../themes/colors';
import { getCredentialAuditTrail } from '../../../../services/credentials';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { FeatureFlagKeys } from '../../../../constants/ff.posthog';

export default ({ editList, isUserEdits, professionalId }) => {
  const shouldUseAuthorizationCredential = useFeatureFlag(FeatureFlagKeys.credentialingV2);
  const [mergedEdits, setMergedEdits] = useState(shouldUseAuthorizationCredential ? [] : editList);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isUserEdits || !professionalId) {
      setMergedEdits(editList || []);
      return;
    }

    const fetchAndMerge = async () => {
      if (!shouldUseAuthorizationCredential) {
        return;
      }
      setLoading(true);
      try {
        const response = await getCredentialAuditTrail(professionalId);
        const auditTrail = response.data || [];
        const combined = [...(editList || []), ...auditTrail];
        combined.sort((a, b) => new Date(b.date) - new Date(a.date));
        setMergedEdits(combined);
      } catch {
        setMergedEdits(editList || []);
      } finally {
        setLoading(false);
      }
    };

    fetchAndMerge();
  }, [editList, isUserEdits, professionalId, shouldUseAuthorizationCredential]);

  const editsLength = mergedEdits.length;
  const isMoreThan99 = editsLength > 99;

  if (loading) {
    return <Spinner />;
  }

  return (
    <TabViewContainer
      TitleTrailing={
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            justifyContent: 'end',
          }}
        >
          <div
            style={{
              backgroundColor: '#b4b7ed',
              height: 40,
              minWidth: 40,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: isMoreThan99 ? 10 : 20,
              paddingLeft: isMoreThan99 ? 10 : 0,
              paddingRight: isMoreThan99 ? 10 : 0,
            }}
          >
            <h3
              className="card-title"
              style={{
                color: Colors.white,
                margin: 0,
                padding: 0,
              }}
            >
              {editsLength}
            </h3>
          </div>
        </div>
      }
      style={{
        alignItems: 'center',
        width: '80%',
      }}
      title="Edits"
      variant="card"
    >
      <div
        style={{
          display: 'flex',
          borderBottom: '1px solid #ededed',
          flex: 1,
          marginLeft: 20,
          marginRight: 20,
          width: '100%',
        }}
      >
        <div style={{ flex: 5 }}>
          <strong>Date</strong>
        </div>
        <div style={{ flex: 3 }}>
          <strong>Author</strong>
        </div>
        <div style={{ flex: 3 }}>
          <strong>Type</strong>
        </div>
        <div style={{ flex: 3 }}>
          <strong>Old Value</strong>
        </div>
        <div style={{ flex: 3 }}>
          <strong>New Value</strong>
        </div>
      </div>
      <EditsRenderData editList={mergedEdits} isUserEdits={isUserEdits} />
    </TabViewContainer>
  );
};
